import React from 'react';
import createReactClass from 'create-react-class';

import { addToast, handleAxiosError } from 'core/notifications';
import axios from '@/util/axios';
import i18n from 'i18next';
import { withContainer } from 'core/cache';

import getInitiativeFormSchemas from '../schemas/getInitiativeFormSchemas';

import InitiativeForm from '../components/initiativeForm';

const InitiativeFormContainer = createReactClass({
  getInitialState() {
    return { formState: {} };
  },

  handleDataErrors({ response }) {
    this.setState(({ formState }) => {
      response.data?.errors?.forEach(({ message, source }) => {
        const field = formState[source.split('data.').pop()];

        if (field) {
          Object.assign(field, { error: message, hasError: true });
        }
      });

      return { formState };
    });

    addToast(i18n.t('form-errors'), 'warning');
  },

  handleLoad({ formState }) {
    this.updateFormState(formState);
  },

  async handleSubmit({ modifiedModel }) {
    let data = modifiedModel;
    const { initiative } = this.props;
    const { id } = initiative.data;

    try {
      ({ data: { data } } = await axios.put(`/api/admin/initiatives/${id}`, { data }));
    } catch (error) {
      return error.response?.status === 422
        ? this.handleDataErrors(error)
        : handleAxiosError(error);
    }

    // back end returns null instead of an empty string for a deleted description
    // https://github.com/intellum/hal-9000/issues/1540#issuecomment-1265401470
    if (modifiedModel.description === '') {
      data.description = '';
    }

    initiative.set(data);
  },

  handleUpdate({ formState }) {
    this.updateFormState(formState);
  },

  updateFormState(newState) {
    this.setState(({ formState }) => ({ formState: { ...formState, ...newState } }));
  },

  render() {
    return (
      <InitiativeForm
        model={this.props.initiative.data}
        onLoad={this.handleLoad}
        onSubmit={this.handleSubmit}
        onUpdate={this.handleUpdate}
        schemas={getInitiativeFormSchemas()}
      />
    );
  },
});

export default withContainer(InitiativeFormContainer, {
  cache: { initiative: { isListener: true } },
  hasRouter: true,
});
